import React from "react"
import { Flex } from "@chakra-ui/react"
import { Link } from "gatsby"

import PostImage from "./PostImage"
import PostBody from "./PostBody"

export default function Post({ fields, frontmatter }) {
  const bodyProps = {
    description: frontmatter.description,
    title: frontmatter.title,
    date: frontmatter.date,
    tag: frontmatter.tag,
  }

  const imageProps = {
    image: frontmatter.image.childImageSharp.gatsbyImageData,
  }

  return (
    <Flex
      direction={{ base: "column", md: "row", lg: "column", xl: "row" }}
      _hover={{ bg: "base.900" }}
      transition="100ms ease"
      layerStyle="foreground"
      to={fields.slug}
      bg="base.d100"
      as={Link}
      w="full"
    >
      <PostImage {...imageProps} />
      <PostBody {...bodyProps} />
    </Flex>
  )
}
